import { render, staticRenderFns } from "./EditResource.vue?vue&type=template&id=2a3cb506&scoped=true"
import script from "./EditResource.vue?vue&type=script&lang=js"
export * from "./EditResource.vue?vue&type=script&lang=js"
import style0 from "./EditResource.vue?vue&type=style&index=0&id=2a3cb506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3cb506",
  null
  
)

export default component.exports